function scrollToSection() {
    let links = document.querySelectorAll(".link-text");
    let href;
    let topOffset;

    if (links.length > 0) {
        for (let index = 0; index < links.length; index++) {
            links[index].addEventListener("click", function (e) {
                e.preventDefault();
                href = links[index].getAttribute("href");

                topOffset =
                    document.querySelector(`${href}`).getBoundingClientRect()
                        .top - 100;

                window.scrollTo({
                    top: topOffset,
                    behavior: "smooth",
                });
            });
        }
    }
}
scrollToSection();
